module.exports = __webpack_public_path__ + "img/bgpic3.2d3a5f95.png";